import { render } from "./ShopsView.vue?vue&type=template&id=6a14b0b9"
import script from "./ShopsView.vue?vue&type=script&lang=js"
export * from "./ShopsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__